export default __webpack_public_path__ + "static/media/pasta1.3929e08d.jpg";